import React from 'react';
import styles from './styles.module.scss';
import Button from 'src/Components/Button_V2';
import PopupModal from 'src/Components/PopupModal_V2';
import classNames from 'classnames';
import Tooltip from '../../Components/Tooltip';
import { ellipsisMiddleCustom } from 'src/utils/text';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { getUserProject } from 'src/redux/actions';
import PageContent from 'src/Components/PageContent';
import Spinner from 'src/Components/Spinner';
import { AppError } from 'src/redux/types';
import { formatCurrency } from '@wolffun/system-currency';
import dayjs from 'dayjs';
import { calculateReceivedToken } from '../../utils';
import { copyToClipboard } from 'src/utils/copyToClipboard';
import icWarning from 'assets/svg/ic_warning_2.svg';
import icCopy from 'assets/svg/ic_copy_V2.svg';
import icRefunded from 'assets/img/refunded.png';
import EmptyList from 'src/Components/EmptyList';

const RefundedDetailModal = ({
  onClose,
  projectId,
  symbol
}) => {
  const dispatch = useTypedDispatch();
  const userProject = useTypedSelector(state => state.userProject.data);
  const invalidated = useTypedSelector(state => state.userProject.invalidated);
  const loading = useTypedSelector(state => state.userProject.loading);
  const error = useTypedSelector(state => state.userProject.error);
  React.useEffect(() => {
    dispatch(getUserProject(projectId));
  }, []);
  const address = userProject !== null && userProject !== void 0 && userProject.otherChainAddress ? userProject.otherChainAddress : (userProject === null || userProject === void 0 ? void 0 : userProject.userAddress) || '';

  const renderContent = () => userProject ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: icRefunded,
    alt: "icon refunded",
    className: styles.iconRefunded
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, "Order ID"), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.strongText
  }, userProject.blockchainId)), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, "Tickets Used"), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.strongText
  }, `${formatCurrency(userProject.pTicketAmount, {
    trimWholeFraction: true
  })} Tickets`)), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, "Investment Amount"), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.strongText
  }, formatCurrency(userProject.busdAmount, {
    withCurrency: true,
    trimWholeFraction: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, `Investment Fee (${userProject.fee}%)`), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.strongText
  }, formatCurrency(userProject.thcAmount, {
    trimWholeFraction: true,
    withCurrency: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, "Wallet Address"), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement(Tooltip, {
    content: "Copied",
    onClick: () => {
      copyToClipboard(address);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.strongText, styles.link)
  }, ellipsisMiddleCustom(address)))), /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallText
  }, "Order Date"), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.strongText
  }, userProject.created ? dayjs(userProject.created).format('DD MMM[,] YYYY') : '')), /*#__PURE__*/React.createElement("div", {
    className: styles.highlightRow
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.smallTextWhite
  }, "Tokens Secured"), /*#__PURE__*/React.createElement("span", {
    className: styles.strongBoldText
  }, `${calculateReceivedToken(userProject.busdAmount, userProject.pricePerToken).toNumber()} ${symbol}`)), userProject.refundInfo && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Copied",
    onClick: () => {
      var _userProject$refundIn;

      copyToClipboard(((_userProject$refundIn = userProject.refundInfo) === null || _userProject$refundIn === void 0 ? void 0 : _userProject$refundIn.txHash) || '');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.transactionContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("img", {
    src: icWarning,
    alt: "icon info",
    className: styles.iconInfo
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.transaction
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, "Refunded Transaction :\xA0", ellipsisMiddleCustom(userProject.refundInfo.txHash)))), /*#__PURE__*/React.createElement("img", {
    src: icCopy,
    alt: "icon copy",
    className: styles.iconCopy
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.btn,
    title: "I got it",
    type: "primary",
    onClick: onClose
  })))) : null;

  const renderError = () => {
    return /*#__PURE__*/React.createElement(EmptyList, {
      title: "Sorry, something went wrong.",
      content: "Please try again.",
      className: styles.empty
    });
  };

  const renderLoading = () => /*#__PURE__*/React.createElement(Spinner, {
    className: styles.spinner,
    size: 150
  });

  return /*#__PURE__*/React.createElement(PopupModal, {
    header: "My Order",
    onClose: onClose,
    className: styles.root
  }, /*#__PURE__*/React.createElement(PageContent, {
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading,
    error: error !== AppError.NO_ERROR,
    invalidated: invalidated,
    loading: loading
  }));
};

export default RefundedDetailModal;